module.exports = __webpack_public_path__ + "cfd3a7d5cd9ab5b183944836a811f801.png";